import { createSelector } from 'reselect';

const selectState = (state) => state.get('header');

const makeSelectAccounts = () =>
  createSelector(
    selectState,
    (state) => state.get('accounts'),
  );

const makeSelectLoadingNotifications = () =>
  createSelector(
    selectState,
    (state) => state.get('loadingNotifications'),
  );

const makeSelectNotifications = () =>
  createSelector(
    selectState,
    (state) => state.get('notifications'),
  );

const makeSelectNotificationsPage = () =>
  createSelector(
    selectState,
    (state) => state.get('notificationsPage'),
  );

const makeSelectOrganization = () =>
  createSelector(
    selectState,
    (state) => state.get('organization'),
  );

const makeSelectData = () =>
  createSelector(
    selectState,
    (state) => state.get('data'),
  );

export {
  makeSelectAccounts,
  makeSelectData,
  makeSelectLoadingNotifications,
  makeSelectNotifications,
  makeSelectNotificationsPage,
  makeSelectOrganization,
};
